import React from 'react'

const MenuMid = () => {
    return (
        <div>
            mid menu
        </div>
    )
}

export default MenuMid
